//
// Generated class TransferNote
//

/// <reference path="TransferNote_ManagedObject.ts" />

class TransferNote extends TransferNote_ManagedObject
{

}
